if (!customElements.get('t26-product-swatch')) {
  class T26ProductSwatch extends HTMLElement {
    constructor() {
      super();
      this.t26HandleCartEvent = this.t26HandleCartEvent.bind(this);
      this.t26HandleSubmit = this.t26HandleSubmit.bind(this);
    }

    connectedCallback() {
      this.form = this.querySelector('.js-product-form');
      this.button = this.querySelector('[name="add"]');
      if (!this.form || !this.button) return;

      this.form.addEventListener('submit', this.t26HandleSubmit, true);
      document.addEventListener('on:cart:add', this.t26HandleCartEvent);
      document.addEventListener('on:line-item:change', this.t26HandleCartEvent);
      this.t26SyncButton();
    }

    disconnectedCallback() {
      if (this.form) this.form.removeEventListener('submit', this.t26HandleSubmit, true);
      document.removeEventListener('on:cart:add', this.t26HandleCartEvent);
      document.removeEventListener('on:line-item:change', this.t26HandleCartEvent);
    }

    /**
     * Returns this Swatch variant's quantity from either cart payload format.
     * @param {object} cart - Enterprise cart snapshot or Shopify Ajax cart.
     * @returns {number}
     */
    t26CartQuantity(cart) {
      const variantId = Number(this.dataset.t26VariantId);
      const item = cart?.items?.find((cartItem) => (
        Number(cartItem.variantId ?? cartItem.variant_id) === variantId
      ));
      return Number(item?.quantity || 0);
    }

    /**
     * Synchronizes the button without requesting /cart.js.
     */
    t26SyncButton() {
      const cartQuantity = this.t26CartQuantity(theme.cart);
      const inCart = cartQuantity > 0 || (cartQuantity === 0 && this.dataset.t26InCart === 'true');
      this.t26SetButtonState(inCart);
    }

    /**
     * Keeps the one-Swatch UI rule current after add, quantity, and remove operations.
     * @param {CustomEvent} event - Enterprise cart event with detail.cart.
     */
    t26HandleCartEvent(event) {
      if (!event.detail?.cart?.items) return;
      this.t26SetButtonState(this.t26CartQuantity(event.detail.cart) > 0);
    }

    /**
     * Stops a duplicate submit before ProductForm sends a request.
     * @param {SubmitEvent} event - Product form submit event.
     */
    t26HandleSubmit(event) {
      const inCart = this.t26CartQuantity(theme.cart) > 0 || this.dataset.t26InCart === 'true';
      if (!inCart) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      this.t26SetButtonState(true);
    }

    /**
     * Applies the available, sold-out, or already-added button state.
     * @param {boolean} inCart - Whether this exact Swatch variant is in the cart.
     */
    t26SetButtonState(inCart) {
      if (!this.button) return;

      const available = this.dataset.t26Available !== 'false';
      this.dataset.t26InCart = String(inCart);
      this.button.disabled = inCart || !available;
      this.button.textContent = inCart
        ? this.button.dataset.t26InCartText
        : (available ? this.button.dataset.t26AvailableText : this.button.dataset.t26SoldOutText);
      if (this.button.disabled) {
        this.button.setAttribute('aria-disabled', 'true');
      } else {
        this.button.removeAttribute('aria-disabled');
      }
    }
  }

  customElements.define('t26-product-swatch', T26ProductSwatch);
}
